import script from "./EventsDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsDetails.vue?vue&type=script&setup=true&lang=ts"

import "./EventsDetails.vue?vue&type=style&index=0&id=516f710a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516f710a"]])

export default __exports__